import { render, staticRenderFns } from "./Token.pc.vue?vue&type=template&id=115074b3&scoped=true&"
import script from "./Token.pc.vue?vue&type=script&lang=js&"
export * from "./Token.pc.vue?vue&type=script&lang=js&"
import style0 from "./Token.pc.vue?vue&type=style&index=0&id=115074b3&lang=scss&scoped=true&"
import style1 from "./Token.pc.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115074b3",
  null
  
)

export default component.exports